import { lg } from '@/src/style/breakpoints';
import { breakpointUntil, breakpointFrom } from '@/src/style/mediaQueries';

export const fromMobileBreakpoint = breakpointFrom.sm;
export const mobileBreakpoint = breakpointUntil.sm;
export const tabletBreakpoint = breakpointUntil.md;
export const fromTabletBreakpoint = breakpointFrom.md;
export const smallDesktopBreakpoint = breakpointUntil.xm;
export const desktopBreakpoint = breakpointUntil.lg;
export const untilDesktopBreakpoint = breakpointUntil.lg;
export const fromDesktopBreakpoint = breakpointFrom.lg;
export const desktopBreakpointReference = lg;
export const untilLargeDesktopBreakpoint = breakpointUntil.ml;
export const fromLargeDesktopBreakpoint = breakpointFrom.ml;
export const extraLargeDesktopBreakpoint = breakpointUntil.xl;
